// extracted by mini-css-extract-plugin
export default {"table":"TransactionListWeb_table__J4vEV","center":"TransactionListWeb_center__OCZ57","right":"TransactionListWeb_right__8X5WL"};